import orderById from './orderById'

const orders = {
  orderById,
}

export default orders
